export function ensureLeadingHashAndSlash(hashPath: string): string {
    return `#${addLeadingSlash(stripHash(hashPath))}`;
}
export function ensureLeadingSlash(hashPath: string): string {
    return `${addLeadingSlash(stripHash(hashPath))}`;
}

export function stripHash(url?: string): string {
    return url?.startsWith('#') ? url.substring(1) : (url ?? '');
}

export function stripHashAndSlash(url: string): string {
    return ensureLeadingHashAndSlash(url).replace('#/', '');
}

export function stripQueryParameters(url: string): string {
    return url.split('?')[0];
}

function addLeadingSlash(path: string): string {
    return hasLeadingSlash(path) ? path : `/${path}`;
}

export function hasLeadingSlash(path: string): boolean {
    return stripHash(path).charAt(0) === '/';
}

export function unifyUrlFormat(path: string): string {
    return stripHash(ensureLeadingHashAndSlash(path));
}
